package org.example.project.enginepalettenkonto

import androidx.compose.runtime.Composable
import org.example.project.dashboard.CusBereichWrapper
import org.example.project.dashboard.DashboardNode

@Composable
fun CusDispoDashboard(node: String = DashboardNode.CUS) {
    CusBereichWrapper("DispoDashboard", node = node)
}
